<template>
  <div
    id="trainee-initial-modal"
    class="modal fade trainee-registration-initial-modal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content modal-borderless">
        <ValidationObserver ref="observer">
          <form>
            <div class="modal-header">
              <h4 class="modal-title">
                {{
                  $tc('registerTrainee', traineesNumber, {
                    count: traineesNumber,
                  })
                }}
              </h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click.stop.prevent="hideModal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 col-lg-4">
                  {{ $t('selectTraining') }}
                </div>
                <div class="col-12 mb-4">
                  <div class="post__date mt-2">
                    {{ courses.length }} {{ $t('trainingsMatch') }}
                  </div>
                </div>
                <div class="col-12" v-if="courses.length">
                  <courseItem
                    v-for="(item, index) in courses"
                    :course="item"
                    :index="index"
                    :key="index"
                    :selectedTraining="selectedTraining"
                  />
                </div>
                <div class="col-12" v-else>
                  <div class="text-center">
                    <div class="alert alert-primary">
                      {{ $t('employeesToBeInitiallyTrainedEmpty') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center" v-if="showAlert">
                <div class="alert alert-primary">
                  {{ $t('noTrainingExist') }}
                </div>
              </div>
              <div class="row" v-if="sessions && sessions.length">
                <div class="col-12 col-lg-4">
                  {{ $t('selectSession') }}
                </div>
                <div class="col-12 mb-4">
                  <div class="post__date mt-2">
                    {{ sessions.length }} {{ $t('sessionsMatch') }}
                  </div>
                </div>
                <div class="col-12">
                  <sessions-row
                    v-for="(item, index) in sessions"
                    :key="index"
                    :session="item"
                    :index="index"
                    :selectedSession="selectedSession"
                  />
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12 mb-3" v-if="selectedSession">
                  <div class="text-danger small">
                    {{
                      $tc('registrationWarningP1', traineesNumber, {
                        traineesNumber: traineesNumber,
                      })
                    }}
                    {{
                      $tc('registrationWarningP2', selectedTraining.name, {
                        selectedTrainingName: selectedTraining.name,
                      })
                    }}
                  </div>
                </div>
                <div class="col-12">
                  <div class="d-flex justify-content-between">
                    <div class="">
                      <div class="" :class="alert.type" v-show="alert.on">
                        {{ alert.text }}
                      </div>
                    </div>
                    <button
                      class="btn btn-primary"
                      :disabled="
                        isSaving || !selectedTraining || !selectedSession
                      "
                      @click.prevent.stop="registerTrainee"
                    >
                      {{
                        $tc('registerTraineeBtn', traineesNumber, {
                          count: traineesNumber,
                        })
                      }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="modal-footer d-flex flex-wrap justify-content-between"
            ></div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { lazyInput } from 'vue-lazy-input'
import { mapFields } from 'vuex-map-fields'
import SessionsRow from './SessionsRow.vue'
import CourseItem from './CourseItem.vue'
export default {
  components: { SessionsRow, CourseItem },
  name: 'InitialTraineeModal',
  directives: {
    lazyInput,
  },
  data() {
    return {
      isLoaded: false,
      q: '',
      isAllSelected: false,
      trainees: [],
      total: 0,
      traineeLang: 'FR',
      selectedTraining: null,
      habilitationCode: null,
      segment: null,
      courses: [],
      showAlert: false,
      selectedSession: null,
      isSaving: false,
      alert: {
        on: false,
        type: '',
        text: '',
      },
    }
  },
  computed: {
    ...mapFields(['user', 'company', 'establishment']),
    traineesNumber() {
      return this.total
    },
    locationName() {
      return function (session) {
        return this.$lodash.get(session, 'locationName', '--')
      }
    },
    sessionsList() {
      return function (course) {
        return this.$lodash.get(course, 'sessions.data', [])
      }
    },
    startAt() {
      return function (course) {
        if (this.$moment(course.startAt).isValid()) {
          return this.$moment(course.startAt).format('DD.MM.YYYY')
        } else return '--'
      }
    },
    sessions() {
      if (this.selectedTraining) {
        return this.$lodash.get(this.selectedTraining, 'sessions.data', [])
      }
      return []
    },
    registrationsCount() {
      return function (session) {
        if (this.$lodash.get(session, 'registrationsCount', false)) {
          let registrationsCount = session.registrationsCount
          return registrationsCount
        } else {
          return 0
        }
      }
    },
    maximumCapacity() {
      return function (session) {
        let maximumCapacity = 0
        if (this.$lodash.get(session, 'maximumCapacity', false)) {
          maximumCapacity = session.maximumCapacity
        }
        return maximumCapacity
      }
    },
    sessionsAviable() {
      return function (session) {
        let registrationsCount = this.$lodash.get(
          session,
          'registrationsCount',
          false
        )
        let maximumCapacity = this.$lodash.get(
          session,
          'maximumCapacity',
          false
        )
        if (registrationsCount && maximumCapacity) {
          if (registrationsCount >= maximumCapacity) return false
          else return true
        }
      }
    },
  },

  mounted() {
    this.isLoaded = true
    this.clearSelectedTraining();
    this.$bus.$on('update-selected-training', (course) => {
      console.log('update-selected-training', course);
      this.selectedTraining = course
      this.selectedSession = null
    })
    this.$bus.$on('update-selected-session', (session) => {
      console.log('update-selected-session', session);
      this.selectedSession = session
    })

    this.$bus.$on('trainee-initial-modal.show', (data) => {
      this.clearSelectedTraining();
      console.log('data == ', data)
      this.trainees = data.trainees
      this.isAllSelected = data.isAllSelected
      this.total = data.total
      this.segment = data.segment
      this.habilitationCode = data.habilitationCode
      this.courses = data.courses
      $('#trainee-initial-modal').modal('show')
    })
  },

  methods: {
    hideModal() {
      this.q = ''
      this.selectedSession = null
      this.courses = null
      this.clearSelectedTraining()
      this.$refs.observer.reset()
      $('#trainee-initial-modal').modal('hide')
    },

    registerTrainee() {
      this.isSaving = true
      let data = {
        clientId: this.user.id,
        sessionId: this.selectedSession.id,
        trainees: this.trainees,
        companyId: this.company.id,
        establishmentId: this.establishment.id,
        clientWfsa: true,
      }
      this.isSaving = true
      this.$store
        .dispatch('trainees/registerTrainee', data)
        .then((response) => {
          this.alert.on = true
          this.alert.text = this.$t('orderWfsaSuccess')
          this.alert.type = 'text-success'
          setTimeout(() => {
            this.alert.on = false
            this.alert.text = ''
            this.alert.type = ''
            this.hideModal()
          }, 5000)
        })
        .finally(() => {
          this.isSaving = false
        })
    },

    clearSelectedTraining() {
      this.selectedTraining = null
      this.selectedSession = null
    },
  },
}
</script>

<style></style>
